import $ from 'jquery';
import _ from 'lodash';
import constants from "Constants.js";
import Immutable    from 'immutable';
import util             from 'util/Util';
import themeService from 'ThemeService.js';
import listService      from 'ListService';
import eventBus from "../EventBus";
import mobileConstants from "../../mobile/commons/MobileFormsConstants"
//==================================================================
// Text utility methods
//==================================================================
class TextUtil {

    focusNextElement(ev){
        var nextElement = $('[tabindex="' + (ev.currentTarget.tabIndex + 1) + '"]').not(':hidden');

        if(nextElement.length===0){
            nextElement = $('[tabindex]').filter(function() {
                return $(this).attr("tabindex") > parseInt(ev.currentTarget.tabIndex)
            }).not(':hidden').first();
        }

        if (nextElement.length) {
            if(!$(nextElement).is(":focus")){
                ev.currentTarget.focus();
                ev.stopPropagation();
                setTimeout(function(){
                    $(nextElement).trigger('focus');
                    $(nextElement).trigger('select');
                },10);
                 return false;
            }
        }
    }

    isIExplorer(){
        // Internet Explorer 6-11
        var isIE = false || !!document.documentMode;
        return isIE;
    }
    isEdge(){
        // Edge 20+
        var isEdge = !this.isIExplorer && !!window.StyleMedia;
        return isEdge;
    }


    isEdgeBrowser() {
        // Edge 20+
        return !this.isIExplorer() && !!window.StyleMedia; 
    }

    replaceLineFeed(text) {
        return text.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }

    stringToBoolean(string){
        switch(string.toString().toLowerCase().trim()){
            case "true": case "yes": case "1": return true;
            case "false": case "no": case "0": case null: return false;
            default: return Boolean(string);
        }
    }

    replaceNewLinesWithCarriageReturns(text){
        return text.replace(/(?:\r\n|\r|\n)/g, '\r\n');
    }

    isDecimalOrNumeric(value){
        var pattern=/^(\d+\.?\d*|\.\d+)$/;
        return pattern.test(value);
    }

    isNumeric(value){
        var pattern=/^\d*$/;
        return pattern.test(value);
    }

    htmlEncode(value){
        return $('<div/>').text(value).html();
    }

    htmlDecode(value){
        return $('<div/>').html(value).text();
    }

    convertFromUnitToPixel(size, unit, dpi){
        let convertedSize;
        let unitHelper = unit;
        if(dpi === ''){
            unitHelper = 'pixel';
        }
        switch (unitHelper){
            case 'inch':
                convertedSize = parseFloat(size * dpi).toFixed(2);
                break;
            case 'mm':
                convertedSize = ((size * dpi) / 25.4);
                break;
            case 'cm':
                convertedSize =  (size * dpi * 0.393701);
                break;
            case 'point':
                convertedSize = ((size * dpi) / 72).toFixed(0);
                break;
            default:
                convertedSize = parseFloat(size).toFixed(0);
                break;
        }

        return convertedSize;
    }

    convertFromPixelToUnit(pixels, dpi, unit) {
        let convertedSize;
        switch (unit) {
            case 'inch':
                convertedSize = (pixels / dpi).toFixed(2);
                break;
            case 'mm':
                convertedSize = ((pixels / dpi) * 25.4).toFixed(2);
                break;
            case 'cm':
                convertedSize = (pixels / dpi / 0.393701).toFixed(2);
                break;
            case 'point':
                convertedSize = ((pixels / dpi) * 72).toFixed(0);
                break;
            case 'pixel':
                convertedSize = parseFloat(pixels).toFixed(0);
                break;
        }
        return Math.round(convertedSize * 100) / 100;
    }

    validatePositiveNumeric(e) {
      // Allow: backspace, delete, tab, escape, enter and .
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
          // Allow: Ctrl+A, Command+A
          (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
          // Allow: home, end, left, right, down, up
          (e.keyCode >= 35 && e.keyCode <= 40)) {
        // let it happen, don't do anything
        return;
      }
      // Ensure that it is a number and stop the keypress
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
      }
    }

    isValidJSON(text){
          try {
              JSON.parse(text);
            } catch (e) {
              return false;
            }
          return true;
    }

    validatePositiveNumericNotPeriod(e) {
      // Allow: backspace, delete, tab, escape, enter and .
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
          // Allow: Ctrl+A, Command+A
          (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
          // Allow: home, end, left, right, down, up
          (e.keyCode >= 35 && e.keyCode <= 40)) {
        // let it happen, don't do anything
        return;
      }
      // Ensure that it is a number and stop the keypress
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
      }
    }
    getText(text, isHtml) {
        let result = text.split("\r").join('<br/>');

        if (isHtml) {
            result = this.replaceLineFeed(text);
        }
        
        return result;
    }

    getNewText(text, isHtml) {
        let result = text;
        if (isHtml.toString()==='false') {
            result=this.htmlEncode(result);
        }
        return result;
    }

    updateTextContent(model, fontChange, silent) {
        var myFont = themeService.resolveThemeFont('fontFamily', model.get('fontFamily')) + ',' +
            themeService.resolveThemeFont('fontSize', model.get('fontSize')) + 'px,' +
            themeService.resolveThemeFont('textWeight', model.get('textWeight')) + ',' +
            themeService.resolveThemeFont('textStyle', model.get('textStyle'));

        const currentWidth = util.extractNum(model.get('width'));
        const currentHeight = util.extractNum(model.get('height'));

        var myText = model.get('text') + '.'; // add space to avoid wrapping if too close.
        if (model.get('factoryKey') === 'control_mask_text_input') {
            myText = model.get('mask') + '.';
        }

        //we keep Input calendar as special control; TODO refactor once start adding more none text based controls
        if (model.get('factoryKey') === "control_date_calendar") {            
              var sizes = util.measureCalendar(myFont);
              if (sizes[0] > currentWidth || fontChange) {                
                    model.set('width', Math.round(sizes[0]), silent);
                }
              if (sizes[1] > currentHeight || fontChange) {                
                    model.set('height', Math.round(sizes[1]), silent);
                }               
        }
        else {//we keep the text control based as used to be in order to no impact other logic
            let skipChangeofHeight = false;

            if (model.get('factoryKey') === "control_drop_down") {
                if (model.get('gridData').length) {
                    myText = model.get('gridData')[0].caption;
                } else {
                    myText = 'Sample';//for sizing without select options
                }
            }

            const _textControls = new Immutable.Set(['control_text', 
                                                     'control_small_text', 
                                                     'control_small_heading', 
                                                     'control_medium_heading', 
                                                     'control_large_heading', 
                                                     'control_link',
                                                     'control_mask_text_input']);

            // Only adjust width on Text controls (text, sm text, sm/md/lg headings)
            if (_textControls.contains(model.get('factoryKey'))) {
                let additionalCss = model.get('factoryKey') === 'control_mask_text_input' ? { 'letter-spacing': '0.5em' } : {};
                var myWidth = util.measureText(myText, myFont, additionalCss);
                var availableWidth = $('#aPageSel').width() - model.get('left');

                if (availableWidth < myWidth) {
                    myWidth = availableWidth;
                }

                // Only Grow
                if (myWidth > currentWidth  || model.get('factoryKey') === 'control_mask_text_input')   {
                    if (util.extractNum(currentHeight) === util.extractNum(model.get('defaultHeight')) || fontChange) {
                        model.set('width', Math.round(myWidth), silent);
                    }
                }
            } 

            const _textControlsIncreaseHeight = new Immutable.Set(['control_checkbox', 
                                                                   'control_radio_button',
                                                                   'control_date_input',
                                                                   'control_time_input',
                                                                   'control_drop_down',
                                                                   'control_text_input',
                                                                   'control_numeric_input',
                                                                   'control_numeric_stepper',
                                                                   'control_password_input',
                                                                   'control_multiple_text_input',
                                                                   'control_button',
                                                                   'control_submit_button',
                                                                   'control_page_button',
                                                                   'control_print_button',
                                                                   'control_play_form_button',
                                                                   'control_play_report_button',
                                                                   'control_clear_filter_button',
                                                                   'control_progress_bar',
                                                                   'control_file_attachment',
                                                                   'control_filter_input']);

            if (_textControlsIncreaseHeight.contains(model.get('factoryKey')) || _textControls.contains(model.get('factoryKey')) && fontChange) {
                let currentHeight = util.extractNum(model.get('height'));
                let availableHeight = $('#aPageSel').height() - model.get('top');
                var myHeight = util.measureHeight(myText, myFont);
            
                if (availableHeight < myHeight) {
                    myHeight = availableHeight;
                }
                
                skipChangeofHeight = listService.selectedCount > 1 && model.get('height') === null;
                
                if ((myHeight >= currentHeight || model.get('factoryKey') === 'control_mask_text_input') && !skipChangeofHeight) {
                    model.set('height', Math.round(myHeight), silent);
                }
            } 
  
            let newHeight = util.extractNum(model.get('height'));
            let newWidth = util.extractNum(model.get('width'));

            if (model.get('factoryKey') === 'control_bullet_text') {
                newHeight = util.measureListTextHeight(myText, myFont, util.extractNum(model.get('width')));
                newWidth = util.measureListTextWidth(myText, myFont, util.extractNum(model.get('height')));
            }

            // Removing "if" verification so selection rectangle can shrink if font size is reduced also.
            let wasHeightChanged = util.extractNum(currentHeight) !== util.extractNum(model.get('defaultHeight'));
            const wasWidthChanged = util.extractNum(currentWidth) !== util.extractNum(model.get('defaultWidth'));
            const isBulletText = model.get('factoryKey') === 'control_bullet_text';

            if ( skipChangeofHeight && listService.selectedCount > 1 ) {
                wasHeightChanged = false;
            }

            // PF-2608 The Bullet text should shrink if Font is made smaller, but other text controls do not share this behavior. So logic was added just for Bullet Text.
            if (((fontChange || wasHeightChanged) && (newHeight > currentHeight)) || isBulletText) {
                model.set('height', Math.round(newHeight), silent);
            }
            if (fontChange || wasWidthChanged || isBulletText) {
                model.set('width', Math.round(newWidth), silent);
            }
            //PF-1326 Set minHeight
            if(model.get('minHeight') ){
                if(!myHeight){
                    const minHeight = util.measureHeight(myText, myFont);

                    if(minHeight > model.get('lowestHeight')){
                        model.set('minHeight', minHeight);
                    }
                    else{
                        model.set('minHeight',  model.get('lowestHeight'));
                    }
                } else {

                    if (myHeight > model.get('lowestHeight')) {
                        model.set('minHeight', myHeight);
                    }
                    else {
                        model.set('minHeight', model.get('lowestHeight'));
                    }

                }
            }

            if(listService.mainKind === constants.KIND_MOBILE){
                const fontSize = parseInt(model.get('fontSize'));
                //PF-10959
                //If in mobile designer use same calculation as in wizard in UpdateFont > changeInputsFontSize
                let height = fontSize * mobileConstants.LINE_HEIGHT_FACTOR;
                height = ( mobileConstants.TEXT_INPUT_MIN_HEIGHT > height) ? mobileConstants.TEXT_INPUT_MIN_HEIGHT: height;
                height += mobileConstants.INPUT_PADDING_FACTOR;
                model.set('height', Math.round(height), silent);
            }

            eventBus.trigger(constants.EV_NAV_POSITION_PROPERTY_CHANGED);
        }
    }

    adjustTextWidth(model, newText){

        const _textControls = new Immutable.Set(['control_text', 'control_small_text', 'control_small_heading', 'control_medium_heading', 'control_large_heading', 'control_link']);

        if(_textControls.contains(model.get('factoryKey'))){

            const myText = newText + '.'; // add space to avoid wrapping if too close.
            const myFont = themeService.resolveThemeFont('fontFamily', model.get('fontFamily')) + ',' +
                themeService.resolveThemeFont('fontSize', model.get('fontSize')) + 'px,' +
                themeService.resolveThemeFont('textWeight', model.get('textWeight')) + ',' +
                themeService.resolveThemeFont('textStyle', model.get('textStyle'));

            const myWidth = util.measureText(myText, myFont, '');

            model.set("width", myWidth, { SILENT: true });
        }
    }

    //========================================================
    // If input string length is greater than a maximum
    // constant, then shorten it to that maximum, appending
    // space-ellipses.
    // Otherwise return the argument unchanged.
    //========================================================
    shortenLabel(str, maxLen = constants.SHORT_LABEL_LEN) {
        const ellipses = ' ...';
        return (str.length > maxLen) ? str.substring(0, maxLen - ellipses.length) + ellipses : str;
    }

    convertSymbolToText(symbol){
        let result = 'none';
        switch (symbol) {
            case ',':
                result = 'comma';
                break;
            case '.':
                result = 'period';
                break;
            case "'":
                result = 'apostrophe';
                break;
        }
        return result;
    }

    convertTextToSymbol(text){
        let result = '';
        switch (text) {
            case 'comma':
                result = ',';
                break;
            case 'period':
                result = '.';
                break;
            case 'apostrophe':
                result = "'";
                break;
        }
        return result;
    }

}
const textUtil = new TextUtil();
export default textUtil;
